import { loadStripe } from "@stripe/stripe-js";

// Loads Stripe.js site-wide so Stripe Radar collects fraud signals on every
// page, not just payment pages. loadStripe memoizes the injection, so the
// payment components' own loadStripe() calls share this load.
export default ({ $config }) => {
  loadStripe($config.stripeKey).catch(() => {}); // best-effort; forms surface their own load errors
};
